// removed by extract-text-webpack-plugin
module.exports = {"container":"KioskError__container___7msk1","error-header":"KioskError__error-header___M8pGU","message":"KioskError__message___2B8Z0","go-back":"KioskError__go-back___3GMUh"};